import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { Button, Card, Col, Form, Input, Row, Select } from 'antd';

import { customerApiEndpoints } from '@/api/endpoints';

import { rules } from '@/utils/validation/FormValidation';

import { handlePostApi } from '@/api/crud';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import LoadingOverlay from '@/utils/loading/loadingOverlay';

const SuperAdminUserCreate = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const navigateToList = () => navigate('/admin/user/list/');

  return (
    <>
      <section className="">
        <Card>
          <Form
            className="username"
            form={form}
            onFinish={(value) => {
              handlePostApi(
                customerApiEndpoints.superAdminCreate,
                value,
                setLoading,
                form,
                navigateToList,
              );
            }}
            layout="vertical"
          >
            <LoadingOverlay loading={loading} />
            <GlobalDivider name="Basic Information" />

            <Row gutter={24}>
              {/*<Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  label="Subscription ID"
                  name="subscriptionId"
                  rules={rules.required}
                  validateTrigger="onChange"
                  hasFeedback
                >
                  <Select
                    showSearch
                    placeholder="Select Subscription"
                    filterOption={(value, option) =>
                      optionSearchFunction(value, option)
                    }
                    options={data?.map((item) => {
                      return {
                        label: item.subscriptionId,
                        value: item.referenceId,
                      };
                    })}
                  />
                </Form.Item>
              </Col>*/}

              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  label="Username"
                  name="username"
                  rules={rules.required}
                  hasFeedback
                  validateTrigger="onChange"
                >
                  <Input placeholder="Username" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  hasFeedback
                  label="Email"
                  name="email"
                  rules={rules.required}
                >
                  <Input placeholder="example@domin.com" autoComplete="off" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  label="Mobile"
                  name="mobileNumber"
                  rules={rules.phoneNumber}
                  validateTrigger="onChange"
                  hasFeedback
                >
                  <Input type="tel" placeholder="98XXXXXXX" maxLength={10} />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  label="First Name"
                  name="firstName"
                  hasFeedback
                  rules={rules.required}
                  validateTrigger="onChange"
                >
                  <Input placeholder="First Name" />
                </Form.Item>
              </Col>

              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  label="Last Name"
                  name="lastName"
                  hasFeedback
                  rules={rules.required}
                  validateTrigger="onChange"
                >
                  <Input placeholder="Last Name" />
                </Form.Item>
              </Col>

              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  hasFeedback
                  label="Address"
                  name="address"
                  rules={rules.required}
                >
                  <Input placeholder="Address" autoComplete="off" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              {/*<Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    {
                      required: true,
                      validator: (_, value) => validatePassword(value),
                    },
                  ]}
                  validateTrigger="onChange"
                  hasFeedback
                >
                  <Input.Password type="password" placeholder="Password" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  label="Confirm Password"
                  name="confirmPassword"
                  rules={[
                    {
                      required: true,
                      message: 'Please confirm your password!',
                    },
                    ({ getFieldValue }) => ({
                      validator: (_, value) =>
                        validateConfirmPassword(getFieldValue)(_, value),
                    }),
                  ]}
                  hasFeedback
                >
                  <Input.Password
                    type="password"
                    placeholder="Confirm Password"
                  />
                </Form.Item>
              </Col>*/}
            </Row>

            <div className="flex justify-end">
              <div className="flex gap-2">
                <Button type="primary" htmlType="submit">
                  Create
                </Button>
                <Button
                  className="auto-danger-btn"
                  onClick={() => navigate(-1)}
                >
                  Back
                </Button>
              </div>
            </div>
          </Form>
        </Card>
      </section>
    </>
  );
};

export default SuperAdminUserCreate;
